export default __webpack_public_path__ + "static/media/ESSC36LTQU01_1920x1080.249b739e.jpg";